import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { PasswordInput } from './PasswordInput';
import './auth.css';

export const APP_TITLE = 'CT-RCS Gateway Console';

export function LoginPage() {
  const { login, loginNotice } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {loginNotice && <div className="session-expired-banner">{loginNotice}</div>}
      <div className="auth-card">
        <h2>{APP_TITLE}</h2>
        <form id="gateway-login-form" onSubmit={handleSubmit} autoComplete="on">
          {error && <div className="auth-error">{error}</div>}
          <div className="auth-field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              name="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <PasswordInput
              id="password"
              name="password"
              value={password}
              onChange={setPassword}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" className="button primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
